// initial state
const state = {
  listOfGenesId: [],
  listOfSelectedLociId: [],
  listOfSelectedLoci: [],
  //loci_listId
};

// getters
const getters = {
  getListOfGenesId: state => {
    if (state.listOfGenesId) {
      return state.listOfGenesId;
    } else {
      return [];
    }
  },
  getListOfGeneIdByAnnot: state => {
    if (state.listOfSelectedLociId) {
      return state.listOfSelectedLociId;
    } else {
      return [];
    }
  },
  getListOfGeneByAnnot: state => {
    if (state.listOfSelectedLoci) {
      return state.listOfSelectedLoci;
    } else {
      return [];
    }
  },

  getSelectedGeneNumber: state => {
    if (state.listOfSelectedLoci) {
      return state.listOfSelectedLoci.length;
    } else {
      return 0;
    }
  },

  getLocusURL(state, getters) {
    return id => {
      return getters.getReleaseUrl + '/' + id;
    };
  },
};

import axios from 'axios';

// actions
const actions = {
  fetchListOfGenes({ commit, rootGetters }) {
    const baseMessage = 'Error during loading loci';
    return new Promise((resolve, reject) => {
      axios
        .get(
          rootGetters.getUrlBase +
            rootGetters.getCurrentSpecies +
            '/' +
            rootGetters.getSelectedReleaseId +
            '/_all/ids'
        )
        .then(
          resp => {
            if (resp.data.error === true) {
              commit('setErrored', true, { root: true });
              let message = resp.data.message
                ? baseMessage + ': ' + resp.data.message
                : baseMessage;
              commit('setErrorMsg', message, { root: true });
            } else {
              commit('setListOfGenes', resp.data);
            }
            resolve(resp);
          },
          err => {
            commit('setErrored', true, { root: true });
            let message = err.response.data.message
              ? baseMessage + ': ' + err.response.data.message
              : baseMessage;
            commit('setErrorMsg', message, { root: true });
            reject(err);
          }
        )
        .catch(() => {
          commit('setErrored', true, { root: true });
          commit('setErrorMsg', baseMessage, { root: true });
        });
    });
  },
  fetchListOfGeneByAnnot({ commit, rootGetters }, o) {
    return new Promise((resolve, reject) => {
      var suffix = '';
      if (o.keyword != '') {
        suffix = '?annotation=' + o.keyword;
      }
      if (o.minallelenb !== '') {
        var symbol = suffix === '' ? '?' : '&';
        suffix += symbol + 'alleleNumber=' + o.minallelenb;
      }
      axios
        .get(
          rootGetters.getUrlBase +
            rootGetters.getCurrentSpecies +
            '/' +
            rootGetters.getSelectedReleaseId +
            '/_search' +
            suffix
        )
        .then(
          resp => {
            if (resp.data.error === true) {
              if (resp.data.message == 'No object found') {
                commit('setListOfSelectedLociId', []);
                commit('setListOfSelectedLoci', []);
              } else {
                commit('setErrored', true, { root: true });
                commit(
                  'setErrorMsg',
                  'Error during searching loci from functional annotation keyword',
                  { root: true }
                );
              }
            } else {
              commit('setListOfSelectedLociId', resp.data);
              commit('setListOfSelectedLoci', resp.data);
            }
            resolve(resp);
          },
          err => {
            commit('setErrored', true, { root: true });
            commit(
              'setErrorMsg',
              'Error during searching loci from functional annotation keyword',
              { root: true }
            );
            reject(err);
          }
        )
        .catch(() => {
          commit('setErrored', true, { root: true });
          commit('setErrorMsg', 'Error during searching loci from functional annotation keyword', {
            root: true,
          });
          console.log('Error during searching loci from functional annotation keyword');
        });
    });
  },
};

// mutations
const mutations = {
  setListOfGenes(state, l) {
    state.listOfGenesId = l;
  },
  setListOfSelectedLociId(state, l) {
    state.listOfSelectedLociId = l.map(o => o.id);
  },
  setListOfSelectedLoci(state, l) {
    state.listOfSelectedLoci = l;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
